<template>
	<div>
		<div class="feature-l">
			<div class="title show-one-lines" v-text="param.title"></div>
			<div class="list">
				<div class="item" v-for="(item,index) in param.list" :key="index">
					<div class="item-t">
						<div class="item-name show-one-lines" v-if="item.label_show == 1" :class="'item-name-'+item.label_style" v-text="item.label_content"></div>
						<span class="show-one-lines" v-text="item.subtitle"></span>
					</div>
					<div class="item-b">
						<template v-for="(value,key) in item.pic_list">
							<template v-if="value.open_type == 'url'">
								<a :href="value.url" target="_blank" class="item-b-img"><img :src="value.pic_url" alt /></a>
							</template>
							<template v-else>
								<router-link :to="value.url" class="item-b-img"><img :src="value.pic_url" alt /></router-link>
							</template>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {

			};
		}
	};
</script>

<style lang="scss" scoped>
	.title {
		line-height: 56px;
		height: 56px;
		font-size: 18px;
		font-weight: 600;
		border-bottom: 1px solid #ebebeb;
		padding:0 20px;
		box-sizing: border-box;
	}

	.feature-l {
		width: 590px;
		height: 362px;
		margin-top: 20px;
		background-color: #fff;

		.list {
			display: flex;
			flex-wrap: wrap;

			.item {
				height: 152px;
				width: 50%;
				padding: 20px;
				box-sizing: border-box;
				border-bottom: 1px solid #ebebeb;

				.item-t {
					display: flex;
					align-items: center;

					.item-name {
						padding: 0 12px;
						height: 20px;
						line-height: 20px;
						margin-right: 8px;
						max-width: 100px;
						box-sizing: border-box;
					}

					.item-name-0 {
						background: #ff9010;
						border-radius: 12px;
						color: #ffffff;
					}

					.item-name-1 {
						border-radius: 2px;
						border: 1px solid #ff9010;
						color: #ff9010;
					}

					span {
						color: #999999;
					}
				}

				.item-b {
					display: flex;
					margin-top: 16px;

					.item-b-img {
						width: 76px;
						height: 76px;

						+.item-b-img {
							margin-left: 14px;
						}

						&:hover {
							opacity: 0.8;
						}
					}
				}
			}

			.item:nth-child(2n) {
				border-left: 1px solid #ebebeb;
			}

			.item:nth-child(3) {
				border-bottom: 0 none;
			}

			.item:nth-child(4) {
				border-bottom: 0 none;
			}
		}
	}
</style>
